export default "__VITE_ASSET__CHDS4QJA__"